// 서버 카트 API 호출 래퍼 (로그인 사용자 전용).
// 모든 응답은 envelope { ok, cart, ... } 형태이며 cart: CartViewDto 를 풀어 반환한다.

import type { CartViewDto, CartItemOptionInput, CartMergeInput } from "@oo/shared";
import { api } from "@/api/client.ts";

// 현재 서버 카트 조회.
export async function getCart(): Promise<CartViewDto> {
  const data = await api.get<{ cart: CartViewDto }>("/cart");
  return data.cart;
}

// 카트에 상품 담기. 갱신된 전체 카트를 반환.
export async function addCartItem(
  productId: string,
  quantity: number,
  options?: CartItemOptionInput[],
): Promise<CartViewDto> {
  const data = await api.post<{ cart: CartViewDto }>("/cart/items", {
    productId,
    quantity,
    // 추가 옵션은 고른 경우에만 보낸다(서버가 상품 소유 여부를 재검증).
    ...(options && options.length > 0 ? { options } : {}),
  });
  return data.cart;
}

// 카트 항목 수량 변경.
export async function updateCartItemQuantity(
  itemId: string,
  quantity: number,
): Promise<CartViewDto> {
  const data = await api.patch<{ cart: CartViewDto }>(`/cart/items/${itemId}`, { quantity });
  return data.cart;
}

// 카트 항목 삭제.
export async function removeCartItem(itemId: string): Promise<CartViewDto> {
  const data = await api.delete<{ cart: CartViewDto }>(`/cart/items/${itemId}`);
  return data.cart;
}

// 서버 카트 전체 비우기.
export async function clearServerCart(): Promise<CartViewDto> {
  const data = await api.delete<{ cart: CartViewDto }>("/cart");
  return data.cart;
}

// 로그인 직후 1회 호출. 비로그인 카트 항목을 서버 카트에 합친다.
export async function mergeGuestCart(items: CartMergeInput["items"]): Promise<CartViewDto> {
  const data = await api.post<{ cart: CartViewDto }>("/cart/merge", { items });
  return data.cart;
}
